import React, { useState, useEffect } from 'react'
import ContratoEditor from './ContratoEditor'
import { useContractModal } from '../../contexts/ContractModalContext'

interface Cliente {
  id: string
  nome_completo: string
  celular: string
  email: string
  telefone?: string
  nome_empresa?: string
  razao_social?: string
  cnpj?: string
  inscricao_estadual?: string
  inscricao_municipal?: string
  endereco?: string
  cep?: string
  bairro?: string
  cidade?: string
  uf?: string
  site?: string
  instagram?: string
  facebook?: string
  whatsapp_anuncios?: string
  responsavel_financeiro?: string
  email_financeiro?: string
  telefone_financeiro?: string
  data_inauguracao?: string
  capital_social?: string
  quantos_colaboradores?: string
  faturamento_empresa?: string
  faturamento_desejado?: string
  cidades_anunciar?: string
  bairros_anunciar?: string
  publico_ideal?: string
  observacoes?: string
  dia_nascimento?: string
  mes_nascimento?: string
  ano_nascimento?: string
  telefone_secundario?: string
}

const GlobalContractEditor: React.FC = () => {
  const { 
    isEditorOpen, 
    selectedContract, 
    closeEditor 
  } = useContractModal()
  
  const [cliente, setCliente] = useState<Cliente | null>(null)
  const [loading, setLoading] = useState(false)

  // Buscar dados do cliente quando o contrato for selecionado
  useEffect(() => {
    const fetchClientData = async () => {
      if (!selectedContract || !selectedContract.cliente_id) {
        console.log('🚫 No contract or cliente_id available')
        return
      }
      
      console.log('🔍 Fetching client data for cliente_id:', selectedContract.cliente_id)
      setLoading(true)
      try {
        // Buscar dados completos do cliente diretamente
        const clientResponse = await fetch(`/api/gestao/clientes?id=${selectedContract.cliente_id}`)
        console.log('👤 Client API response status:', clientResponse.status)
        
        if (clientResponse.ok) {
          const clientResult = await clientResponse.json()
          console.log('👤 Client data loaded:', clientResult.data?.nome_completo)
          setCliente(clientResult.data)
        } else {
          console.error('❌ Failed to fetch client data - status:', clientResponse.status)
        }
      } catch (error) {
        console.error('❌ Error fetching client data:', error)
      } finally {
        setLoading(false)
      }
    }

    if (isEditorOpen && selectedContract && !cliente) {
      fetchClientData()
    }
  }, [isEditorOpen, selectedContract, cliente])

  if (!isEditorOpen || !selectedContract) {
    return null
  }


  const handleSave = async (conteudo: string, observacoes?: string) => {
    try {
      const response = await fetch(`/api/contratos?id=${selectedContract.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          conteudo_editado: conteudo,
          observacoes: observacoes
        })
      })

      if (response.ok) {
        closeEditor()
        // Trigger a refresh of the contracts list
        window.location.reload()
      } else {
        const result = await response.json()
        alert('Erro ao salvar contrato: ' + result.error)
      }
    } catch (error) {
      console.error('Erro ao salvar contrato:', error)
      alert('Erro ao salvar contrato')
    }
  }

  const handleActivate = async () => {
    try {
      const response = await fetch(`/api/contratos?id=${selectedContract.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          status: 'ativo'
        })
      })

      if (response.ok) {
        alert('Contrato ativado com sucesso!')
        closeEditor()
        window.location.reload()
      } else {
        const result = await response.json()
        alert('Erro ao ativar contrato: ' + result.error)
      }
    } catch (error) {
      console.error('Erro ao ativar contrato:', error)
      alert('Erro ao ativar contrato')
    }
  }

  const handleGeneratePDF = async () => {
    try {
      const response = await fetch(`/api/contratos/pdf?id=${selectedContract.id}`, {
        method: 'POST'
      })

      if (response.ok) {
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${selectedContract.numero_contrato}.pdf`
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } else {
        const result = await response.json()
        alert('Erro ao gerar PDF: ' + result.error)
      }
    } catch (error) {
      console.error('Erro ao gerar PDF:', error)
      alert('Erro ao gerar PDF')
    }
  }

  return (
    <ContratoEditor
      contrato={selectedContract}
      cliente={cliente}
      onSave={handleSave}
      onClose={closeEditor}
      onGeneratePDF={handleGeneratePDF}
      onActivate={handleActivate}
    />
  )
}

export default GlobalContractEditor
